import React, {useState, useEffect} from 'react';
import {Link} from "react-router-dom";
import { submitCCPayment, submitCCStatus } from '../reducers/cart';
import { useDispatch, useSelector } from "react-redux";

const CreditCardForm = () => {
  const [ firstName, setFirstName ] = useState('');
  const [ lastName, setLastName ] = useState('');
  const [ amount, setAmount ] = useState('');
  const [ isSubmitting, setIsSubmitting ] = useState(false);
  const [ alertMessage, setAlertMessage ] = useState('');
  const [ token, setToken ] = useState('');
  const dispatch = useDispatch();
  const ccStatus = useSelector(submitCCStatus);

    useEffect(() => {
      window.CollectJS.configure({
        variant: 'inline',
        styleSniffer: true,
        callback: (token) => {
          finishSubmit(token);
        },
        fields: {
          ccnumber: {
            placeholder: 'CC Number',
            selector: '#ccnumber'
          },
          ccexp: {
            placeholder: 'CC Expiration',
            selector: '#ccexp'
          },
          cvv: {
            placeholder: 'CVV',
            selector: '#cvv'
          }
        }
      });
  }, []);

  const finishSubmit = async(token) => {
    await setToken(token.token);
    console.log("AMOUNT", amount);
    setIsSubmitting(false);
    setAlertMessage("The form was submitted. Check the console to see the output data.");
    console.log("TOKEN::", token.token);

    dispatch(submitCCPayment({token: token.token, amount: amount}));
  }

  const handleSubmit = (event) => {
    event.preventDefault();
    setIsSubmitting(true);
    console.log(firstName);
    window.CollectJS.startPaymentRequest();
    console.log("End payment request");
  }

    return (
      <div className="App">
        <div>
          <h1>Cart Page</h1>
          <Link to="/">Home Page</Link>
          <br />
          <Link to="/lightbox">Lightbox cart page</Link>
        </div>
        <br />
        { alertMessage && (
          <div className="alert">
            {alertMessage}
          </div>
        )}
        <form onSubmit={handleSubmit}>
          <div>
            <input
              type="text"
              name="firstName"
              placeholder="First Name"
              onChange={event => setFirstName(event.target.value)}
              value={firstName}
            />
          </div>
          <div>
            <input
              type="text"
              name="lastName"
              placeholder="Last Name"
              onChange={event => setLastName(event.target.value)}
              value={lastName}
            />
          </div>
          <div>
            <input
              type="text"
              name="amount"
              placeholder="Amount"
              onChange={event => setAmount(event.target.value)}
              value={amount}
            />
          </div>
            <div id="ccnumber" />
            <div id="ccexp" />
            <div id="cvv" />
          <button
            type="submit"
            disabled={isSubmitting}
          >
            Submit
          </button>
        </form>
      </div>
    );
}

export default CreditCardForm;